module.exports = {
    tag: 'swift',
    quality: 0.4,
    speed: 0.4
};